import React from 'react';

// JSON-LD structured data schema type
export interface JsonLdSchema {
    '@context': string | string[];
    '@type': string;
    [key: string]: unknown;
}

interface StructuredDataProps {
    children: JsonLdSchema;
}

export function StructuredData({ children }: StructuredDataProps) {
    return <script type="application/ld+json">{JSON.stringify(children, null, 2)}</script>;
}
